/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum DocumentTemplateContextType {
    ExportTicket = 1,
    ExportMissionByTicket = 2,
    ActivationMissionByTicket = 3,
    ExportMissionByTask = 4,
    ActivationMissionByTask = 5,
    ExportMission = 6,
    ActivationMission = 8,
    MissionBase = 10,
    FilledForm = 11,
    FilledFormByChat = 12,
    FilledFormByTask = 13,
    Issue = 14,
    MessageIssue = 15,
    TicketIssue = 16,
    MissionIssue = 17,
    KnowledgePathCertificate = 19,
    PrintQr = 20,
    PrintReservedQr = 21,
    OrderIssue = 22,
    ConnectedIssue = 23,
}
